<template>
  <CadastroBase
    nomePlural="FuncionarioPontoPeriodos"
    nomeSingular="FuncionarioPontoPeriodo"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12">
      <v-row class="mt-4">
        <v-col cols="12" md="6">
          <CampoData
            @date="recurso.inicioPeriodo = $event"
            label="Inicio_do_periodo"
            name="inicioPeriodo"
          />
        </v-col>
        <v-col cols="12" md="6">
          <CampoData
            @date="recurso.finalPeriodo = $event"
            label="Final_do_periodo"
            name="finalPeriodo"
          />
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col cols="12" md="6">
          <v-checkbox v-model="recurso.bloquearMovimentacao">
            <template v-slot:label>
              <p>{{ $t("Bloquear_movimentacao") }}</p>
            </template>
          </v-checkbox>
        </v-col>
      </v-row> -->
    </v-col>
  </CadastroBase>
</template>

<script>
import DataService from "@/services/pessoal/FuncionarioPontoPeriodoDataService";

import CadastroBase from "@/components/base/Crud/CadastroBase";

export default {
  name: "CadastroFuncionarioPontoPeriodo",
  components: { CadastroBase },

  data() {
    return {
      DataService: DataService,
      DeveLimparForm: true,
      recurso: {
        inicioPeriodo: "",
        finalPeriodo: "",
        encerrado: false,
        bloquearMovimentacao: false,
        publicar: false,
      },
    };
  },

  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
    limpaForm() {
      this.recurso = {
        inicioPeriodo: "",
        finalPeriodo: "",
        encerrado: false,
        bloquearMovimentacao: false,
        publicar: false,
      };
    },
  },
};
</script>

<style scoped>
#app p {
  margin: 0 !important;
}
</style>
